import { render, staticRenderFns } from "./HomeLeft.vue?vue&type=template&id=2277e15e&scoped=true"
import script from "./HomeLeft.vue?vue&type=script&lang=js"
export * from "./HomeLeft.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2277e15e",
  null
  
)

export default component.exports